module.exports = __webpack_public_path__ + "img/square-j.1f8a5c9c.svg";